// フロントページ - 新着記事
(function ($) {
  $(document).ready(function () {
    $('.js-modal-open').on('click',function(){
        $('.js-modal').fadeIn();
        return false;
    });
    $('.js-modal-close').on('click',function(){
        $('.js-modal').fadeOut();
        $(".modal__content_post").empty();
        return false;
    });
  });

  // モーダルへ記事データ受け渡し
  $( '.js-modal-open' ).on( 'click', function(){

    var url = $(this).data('url');

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        'action' : 'my_ajax_get_posts',
        'url' : url
      }
      }).done(
        function (data) {
          $(".modal__content_post").append(data);
        }).fail(function () {
          alert("読み込み失敗");
        });

      });

})(jQuery);